<template>
  <div v-if="this.size && this.size == 16">
    <email-16 :class="iconColorClass" />
  </div>
  <div v-else-if="this.size && this.size == 20">
    <email-20 :class="iconColorClass" />
  </div>
  <div v-else-if="this.size && this.size == 24">
    <email-24 :class="iconColorClass" />
  </div>
  <div v-else-if="this.size && this.size == 32">
    <email-32 :class="iconColorClass" />
  </div>
  <div v-else><email-16 :class="iconColorClass" /></div>
</template>

<script>
import { Email16, Email20, Email24, Email32 } from "@carbon/icons-vue";

export default {
  name: "PcEmailIcon",

  components: {
    "email-16": Email16,
    "email-20": Email20,
    "email-24": Email24,
    "email-32": Email32,
  },

  props: {
    size: {
      type: [Number, String],
      validator: function (value) {
        return [16, "16", 20, "20", 24, "24", 32, "32"].includes(value);
      },
      required: false,
      default: 16,
    },
    iconColorClass: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped></style>
